/**
 * /interest: the address to give advertisers, with their utm_ values,
 * e.g. /interest?utm_source=facebook&utm_medium=paid_social
 *
 * It sends the visitor straight on to the REDCap EOI form with a booking
 * key, so that they can book a screening call afterwards, and with the five
 * utm_ values, so that the advert's tracking reaches the form.
 */
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import sharedConfig from "../../shared-config.json";
import { goToInterestForm, utmParams, withUtm } from "../utilities/screeningApi";

export default function InterestPage() {
  const { search } = useLocation();

  useEffect(() => {
    goToInterestForm(utmParams(search), { replace: true });
  }, [search]);

  // For when the redirect stalls. The build-time address, since the live
  // one comes from the API.
  const formUrl = sharedConfig.urls?.eoi;

  return (
    <main
      id="main-content"
      className="font-body min-h-screen flex items-center"
      style={{ backgroundColor: "var(--bg-hero)" }}
    >
      <div className="container text-center space-y-4">
        <p className="text-lg md:text-xl">Taking you to the interest form…</p>
        {formUrl && (
          <p className="text-text-muted">
            If nothing happens,{" "}
            <a href={withUtm(formUrl, utmParams(search))} className="underline hover:text-text-main">
              open the interest form
            </a>
            .
          </p>
        )}
      </div>
    </main>
  );
}
